import { Injectable } from '@angular/core';

export interface NoraPulse {
  adminModule?: boolean;
  hrmsModule?: boolean;
  teacherModule?: boolean;
  libraryModule?: boolean;
  feeModule?: boolean;
  assetModule?: boolean;
  eStoreModule?: boolean;
  applicationTrackerModule?: boolean;
  transportModule?: boolean;
  governanceModule?: boolean;
  misModule?: boolean;
  [key: string]: boolean | undefined;
}

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  private readonly STORAGE_KEY = 'noraPulse';

  /** Persist flags from the login API response. */
  setFlags(flags: NoraPulse): void {
    if (flags) {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(flags));
    }
  }

  /** Retrieve stored flags, or null if not yet set. */
  getFlags(): NoraPulse | null {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    if (!stored) return null;
    try {
      return JSON.parse(stored) as NoraPulse;
    } catch {
      return null;
    }
  }

  /**
   * Returns true if the given feature is enabled.
   *
   * - No flags loaded yet (before GDS API responds) → true (show all, safe fallback).
   * - Flags loaded, key present                     → honour the boolean value.
   * - Flags loaded, key absent                      → false (API is opt-in; missing = disabled).
   */
  isEnabled(featureKey: string): boolean {
    const flags = this.getFlags();
    if (!flags) return true;                     // fallback: no data yet
    if (!(featureKey in flags)) return false;    // opt-in: not listed = off
    return flags[featureKey] === true;
  }

  /** Remove flags on logout. */
  clearFlags(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }
}
